import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dEventRepository from "~/repository/UiMeet3d/UiMeet3dEventRepository";
import UiMeet3dEvent from "~/models/UiMeet3d/UiMeet3dEvent";

class UiMeet3dEventStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable uiMeet3dEvents = [];

  /**
   * @property {UiMeet3dEvent}
   */
  @observable uiMeet3dEvent = null;

  /**
   * @property {number|null}
   */
  uiMeet3dEventId = null;

  uiMeet3dEventRepository = null;

  constructor() {
    super();

    // this.pagination.itemsPerPage = 25;

    this.uiMeet3dEventRepository = new UiMeet3dEventRepository();

    this.setDefaultSearchParams();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
      type: [],
    };

    if (this.searchParams.type.length !== 0) {
      params.type = this.searchParams.type;
    }

    return this.uiMeet3dEventRepository.fetch(params).then(response => {
      this.processEntities(response.data.uiMeet3dEvents);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(uiMeet3dEvents = []) {
    this.uiMeet3dEvents = [];

    uiMeet3dEvents.forEach(uiMeet3dEventArray => {
      const uiMeet3dEvent = new UiMeet3dEvent(uiMeet3dEventArray);

      this.uiMeet3dEvents.push(uiMeet3dEvent);
    });
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Events.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }

  /**
   * Change the pagination page and fetch the Ui Meet3d Events.
   */
  @action
  search() {
    this.pagination.currentPage = 1;

    return this.loadIndex();
  }

  @action
  getOne() {
    return this.uiMeet3dEventRepository.fetchOne(this.uiMeet3dEventId).then(response => {
      this.uiMeet3dEvent = new UiMeet3dEvent(response.data.uiMeet3dEvent);
    });
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.uiMeet3dEventRepository
      .create(data)
      .then(response => {
        this.uiMeet3dEvent = new UiMeet3dEvent(response.data.uiMeet3dEvent);
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  @action
  update(data) {
    this.isSaving = true;

    return this.uiMeet3dEventRepository
      .update(this.uiMeet3dEventId, data)
      .then(response => {
        this.uiMeet3dEvent = new UiMeet3dEvent(response.data.uiMeet3dEvent);
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.type = [];
  }
}

export default UiMeet3dEventStore;
